import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Leaf } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { setMember } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        window.history.replaceState(null, "", window.location.pathname);
        setMember(data);
        navigate(["owner", "admin", "support", "marketing"].includes(data.role) ? "/admin" : "/my-wellness-journey", { replace: true, state: { user: data } });
      })
      .catch((err) => {
        window.history.replaceState(null, "", window.location.pathname);
        const detail = err?.response?.data?.detail;
        navigate("/login", {
          replace: true,
          state: {
            authError:
              typeof detail === "string" && detail
                ? detail
                : "Google sign-in could not be completed. Please try again.",
          },
        });
      });
  }, [navigate, setMember]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ivory">
      <Leaf className="h-8 w-8 animate-pulse text-forest" />
      <p className="text-sm text-taupe">Signing you in...</p>
    </div>
  );
}
